import { SELF_GUIDED_TOURS_FIELD_NAMES } from '../constants';

export const SELF_GUIDED_TOURS_CONFIG = {
  SELF_GUIDED_TOUR_BUTTON_LABEL: {
    NAME: SELF_GUIDED_TOURS_FIELD_NAMES.SELF_GUIDED_TOUR_BUTTON_LABEL,
    LABEL: 'Custom Button Label',
    PLACEHOLDER: "e.g. Start Tour, Let's Go!",
    HELPER_TEXT:
      'Enter the wording you want displayed on the tour start button. Label will default to “Start Tour” if left empty.',
  },
  SELF_GUIDED_TOUR_URL: {
    NAME: SELF_GUIDED_TOURS_FIELD_NAMES.SELF_GUIDED_TOUR_URL,
    LABEL: 'Self-Guided Tour URL',
    PLACEHOLDER: 'https://',
    HELPER_TEXT: '',
  },
  TOURS_EXPORT_ONLY_FAVORITE_UNIT: {
    NAME: SELF_GUIDED_TOURS_FIELD_NAMES.TOURS_EXPORT_ONLY_FAVORITE_UNIT,
    PRIMARY: 'Only Export Favorite Unit',
    SECONDARY:
      'Limit exports to the unit marked as Favorite during the tour.',
  },
};

export const SELF_GUIDED_TOURS_TEXT_FIELDS_ORDERED = [
  SELF_GUIDED_TOURS_CONFIG.SELF_GUIDED_TOUR_URL,
  SELF_GUIDED_TOURS_CONFIG.SELF_GUIDED_TOUR_BUTTON_LABEL,
];
